import type { EnvironmentConfig } from './environment.types';

/**
 * UAT environment configuration.
 * Used for user acceptance testing.
 */
export const environment: EnvironmentConfig = {
  name: 'UAT',
  production: false,
  api: {
    proxyPath: 'https://api.uat.open-pay.com/merchantPanel',
    target: 'https://api.uat.open-pay.com/merchantPanel',
  },
  swaggerUrl: 'https://api.uat.open-pay.com/merchantPanel/swaggerJson',
};
